// extracted by mini-css-extract-plugin
module.exports = {"container":"_2g-Y1HUiAW0quh39MWzDCa","restaurantManagersList":"_358qGOwNehLvt5JQj-eEEk","item":"_2SDFz0z-rXJ1NM6OYuBIEB","dot":"_2DSxNIC_KU0ZUS2btR8wHQ"};